<template>
	<div class="journal-list" style="margin-right: 3rem;">
		<app-table
			:add-icon="canCreate"
			:check-all="checkAll"
			:clear-filter="!isSync"
			:columns="columns"
			:current-page="currentPage"
			:disabled-delete="disabledDelete"
			:include-filter="!isSync"
			:selectable="!isSync || showSync"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="itemsQuantity"
			:last-page="lastPage"
			name="journal"
			:name-tooltip="titleTooltip"
			:new-seat="canCreate"
			padding="px-0"
			:rows="rows"
			:show-new-seat="canCreate"
			:delete-seat="canDelete && !isSync"
			:tooltip-delete="deleteTooltip"
			@add-icon="addAIconAction"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search', $event)"
			@on-selected-all="$emit('on-selected-all', $event)"
			@row-is-selected="$emit('row-is-selected', $event)"
			@table-option-event="$emit('on-table-option', $event)"
			@create-seat="$emit('create-seat', $event)"
			@delete-seat="$emit('delete-seat', $event)"
			@create-action="$emit('create-action', $event)"
			@clear-filter="$emit('clear-filter')"
		>
			<template slot="rows" slot-scope="props">
				<td class="code" v-show="showRow(columns, 1)">
					{{ props.row.code }}
				</td>
				<td class="gloss w-30" v-show="showRow(columns, 2)">
					<p class="mb-0">
						<span class="desktop">Descripción: </span>
						<span v-if="props.row.gloss && !mobile">
							<span v-if="props.row.gloss.length < 17">{{ props.row.gloss }}</span>
								<v-tooltip top v-else>
									<span slot="activator">{{ props.row.gloss}}</span>
									<span>{{ props.row.gloss }}</span>
								</v-tooltip>
						</span>
						<span v-else>{{ props.row.gloss }}</span>
					</p>
				</td>
				<td v-show="showRow(columns, 3)">{{ props.row.documentId }}</td>
				<td v-show="showRow(columns, 4)">	<app-tooltip-button
									:img="props.row.status === 1 ? '/static/icon/check-all.svg' : '/static/icon/check-bold.svg'"
									:text="statusName(props.row)"
								/></td>
				<td v-show="showRow(columns, 5)">{{ props.row.typeRegister && props.row.typeRegister.code ? props.row.typeRegister.code : '' }}</td>
				<td style="height: 50px; width: 65px;" v-show="showRow(columns, 6)">{{ props.row.date | exactDate }}</td>
				<td
					class="d-flex justify-space-between align-center  ma-2"
					v-show="showRow(columns, 7)"
					@click.stop="stopClick"
				>
					<app-tooltip-button
						color="primary"
						class="mobile"
						img='/static/img/icons/see-detail.svg'
						text="Ver Detalle"
						:width="17"
						@click-icon="$emit('click-icon', { action: 'see-detail', row: props.row })"
					/>

					<app-tooltip-button
						v-if="props.row.typeRegister && props.row.typeRegister.code === 'Contabilidad' && props.row.status !== 1 && canEdit"
						color="success"
						class="mobile"
						img='/static/img/icons/to-declare.svg'
						text="Confirmar"
						:width="16"
						@click-icon="$emit('confirm-seat', props.row.id)"
					/>
					<app-tooltip-button
						v-if="props.row.typeRegister && props.row.typeRegister.code === 'Contabilidad' && canCreate"
						:color="props.row.clone === 1 ? 'warning': 'success'"
						class="mobile"
						:disabled="loading"
						icon='filter_none'
						:text="props.row.clone === 1 ? 'Asiento Pendiente de Revisión' : 'Clonar'"
						:size="16"
						@click-icon="$emit('clone-seat', props.row)"
					/>
					<!-- <app-tooltip-button
						v-if="canDelete"
						color="error"
						class="mobile"
						img='/static/img/icons/anular.svg'
						text="Anular"
						:width="16"
						@click-icon="$emit('click-icon', { action: 'cancel', row: props.row })"
					/> -->
					<app-tooltip-button
						color="success"
						class="mobile"
						:disabled="loading"
						icon='print'
						text="Imprimir Asiento"
						:size="16"
						@click-icon="$emit('print-seat', props.row)"
					/>
					<app-tooltip-button
						v-if="props.row.register"
						color="info"
						class="mobile"
						:disabled="loading"
						icon='article'
						text="Detalles de registro."
						:size="16"
						@click-icon="$emit('detail-document', props.row)"
					/>
					<div class="collapse-menu">
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="$emit('detail-journal-list', props.row)">
										<img
										src="/static/img/icons/see-detail.svg"
										alt="icon-detail"
										width="15px"
										height="15px">
										<span class="ml-1 color-secondary">Ver detalle</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile v-if="canEdit" class="btn-menu-content">
									<v-list-tile-title class="menu-content">
										<img src="/static/img/icons/to-declare.svg"
										alt="icon-delete"
										class="menu-option-icon"
										width="15px"
										height="15px">
										<span class="ml-1 color-secondary">Declarar</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile v-if="canEdit" class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="$emit('click-icon', { action: 'new-seat', row: props.row })">
										<img
										src="/static/img/actions-list/edit.svg"
										alt="icon-edit"
										class="menu-option-icon"
										width="15px"
										height="15px">
										<span class="ml-1 edit">Editar</span>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';


function statusName({ status }) {
	return status === 1 ? 'Mayorizado' : 'Pendiente';
}

function addAIconAction() {
	this.$emit('add-icon');
}

function destroyed() {
	window.removeEventListener('resize', this.reziseMobile);
}

function reziseMobile() {
	const windowWidth = window.innerWidth;
	this.mobile = windowWidth <= 768;
}

function created() {
	window.addEventListener('resize', this.reziseMobile);
	this.reziseMobile();
}

function data() {
	return {
		deleteTooltip: 'Eliminar Asiento',
		titleTooltip: 'Nuevo Asiento (ctrl + alt + L)',
		columns: [
			{
				id: 1,
				name: 'Asiento',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Descripción',
				value: 'description',
				checked: true,
				visible: true,
			},
			{
				id: 3,
				name: '# Documento',
				value: 'document',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Estado',
				value: 'status',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Origen',
				value: 'origin',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 6,
				name: 'Fecha',
				value: 'date',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 7,
				name: 'Acciones',
				checked: true,
				visible: true,
				flagVisible: true,
			},
		],
		mobile: false,
	};
}

export default {
	name: 'journal-list',
	components: {
		appTooltipButton,
	},
	data,
	created,
	destroyed,
	methods: {
		addAIconAction,
		statusName,
		reziseMobile,
	},
	props: {
		checkAll: {
			default: false,
			type: Boolean,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		itemsQuantity: [Number, String],
		itemsTotalQuantity: [Number, String],
		disabledDelete: {
			type: Boolean,
			required: false,
		},
		loading: {
			type: Boolean,
			required: false,
		},
		isSync: {
			type: Boolean,
			default: false,
		},
		showSync: {
			type: Boolean,
			default: false,
		},
		// Permisos (parametrización). Por defecto true para no romper otros usos.
		canCreate: {
			type: Boolean,
			default: true,
		},
		canEdit: {
			type: Boolean,
			default: true,
		},
		canDelete: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.journal-list {
	font-family: font(AvenirRegular) !important;
	font-size: size(small11) !important;
}

.collapse-menu {
	display: none;

	@media (max-width: 768px) {
		align-items: center;
		display: block;
		grid-column: 4/5;
		grid-row: 1;
		height: 100%;
		justify-content: center;

		.v-menu {
			align-items: center;
			display: flex;
			height: 100%;
			justify-content: center;

			.v-btn {
				background-color: color(btn-green);
				height: 25px;
				margin: 0;
				width: 25px;
			}
		}
	}
}

.btn-menu-content {
	border-bottom: 1px solid color(grey-background-table);
}

.color-secondary {
	color: map-get($colors, secondary);
	font-family: map-get($fonts, AvenirRegular);
	font-size: map-get($sizes, small11);
}

.edit {
	color: map-get($colors, green-icon);
	font-family: map-get($fonts, AvenirRegular);
	font-size: map-get($sizes, small11);
}

.gloss {
	@media (max-width: 768px) {
		background-color: #eceff1;
		display: grid;
		grid-column: 1/7;
		grid-row: 2;
		white-space: nowrap;
	}
}

.code {
	@media (max-width: 768px) {
		display: grid;
		grid-column: 2/4;
		grid-row: 1;
	}
}

.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}
.w-30 {
	@media (min-width: 768px) {
		width: 30%;
	}
}

.desktop {
	@media (min-width: 768px) {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/journal/journal-list.vue